import withApiData from "../withApiData";
import Footer from "./Footer";
import Placeholder from "./Placeholder";

export default withApiData(Footer, Placeholder);
